import { getChannelRule } from '../../services/api/channelRule.api';
import { GET_CHANNEL_RULE_SINGLE_REQUEST, GET_CHANNEL_RULE_SINGLE_SUCCESS, GET_CHANNEL_RULE_SINGLE_FAILURE } from '../types';
import { transformChannelRuleDetail } from '../../transforms/allocation';
import { transformError } from '../../transforms/error';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
		data: transformChannelRuleDetail({}),
	},

	getters: {
		getForm: (state) => (channels = []) => {
			const getCategorySkuKeys = (data) => {
				const isSetCategory = data.isCategoryConfig;
				return {
					categoryIds: data.categoryIds,
					isCategoryAll: !!(isSetCategory && !data.categoryIds.length),

					isSkuAll: !!(!isSetCategory && !data.products.length),
					skuIds: data.products.map((item) => item.sku),
					skuCodes: data.products.map((item) => item.sku),

					excludeSkuIds: data.itecSkuExclusions.map((item) => item.sku),
					excludeSkuCodes: data.itecSkuExclusions.map((item) => item.sku),
				};
			};

			const getAllocateChannels = (data) => {
				return {
					allocateChannels: channels.map((channel) => {
						const item = data.channelAllocations.find((_item) => _item.channelId === channel.id);
						return {
							id: channel.id,
							name: channel.name,
							percentage: item !== undefined
								? item.percentage
								: 0,
						};
					}),
				};
			};

			const getAllocateConditions = (data) => {
				return {
					allocateConditions: data.conditions.map((cond) => {
						const allocations = cond.allocations || [];
						return {
							minQty: cond.conditionQty,
							channels: channels.map((channel) => {
								const item = allocations.find((_item) => _item.channelId === channel.id);
								return {
									id: channel.id,
									name: channel.name,
									qty: item !== undefined
										? item.qty
										: null,
								};
							}),
						};
					}),
				};
			};

			return {
				name: state.data.name,
				priority: Number(state.data.priority || null),
				status: Boolean(state.data.isActive),
				onlineGroup: null,
				...getCategorySkuKeys(state.data),
				...getAllocateChannels(state.data),
				...getAllocateConditions(state.data),
			};
		},
	},

	mutations: {
		[GET_CHANNEL_RULE_SINGLE_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
			state.data = {};
		},
		[GET_CHANNEL_RULE_SINGLE_SUCCESS](state, data) {
			state.isLoading = false;
			state.data = transformChannelRuleDetail(data);
		},
		[GET_CHANNEL_RULE_SINGLE_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
	},

	actions: {
		async getChannelRule({ commit }, id) {
			try {
				commit(GET_CHANNEL_RULE_SINGLE_REQUEST);
				const { data } = await getChannelRule(id);
				commit(GET_CHANNEL_RULE_SINGLE_SUCCESS, data);
			} catch (error) {
				commit(GET_CHANNEL_RULE_SINGLE_FAILURE, error);
			}
		},
	},
};
